import React from "react";
import styles from "./button-submit.module.css";

type ButtonSubmitProps = {
  text: string;
  onClick: () => void;
  buttonType?: "submit" | "button" | "reset";
  color?: "primary" | "delete";
  disabled?: boolean;
  classes?: string;
  translate?: (text: string) => string;
};

const ButtonSubmit: React.FC<ButtonSubmitProps> = ({
  text,
  onClick,
  buttonType = "submit",
  color = "primary",
  disabled = false,
  classes = "",
  translate = (t) => t,
}) => {
  const buttonClass = `${styles.btnPrimary} ${styles[color]} ${classes}`;

  return (
    <button
      type={buttonType}
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
    >
      {translate(text)}
    </button>
  );
};

export default ButtonSubmit;
